import * as React from 'react'

type Element = ((state: boolean) => React.ReactElement<any>) | React.ReactElement<any>

const useHover = (element: Element): [React.ReactElement<unknown>, boolean] => {
  const [state, setState] = React.useState(false)

  const onMouseEnter =
    (originalOnMouseEnter: React.MouseEventHandler) => (event: React.MouseEvent) => {
      if (originalOnMouseEnter) originalOnMouseEnter(event)

      setState(true)
    }

  const onMouseLeave =
    (originalOnMouseLeave: React.MouseEventHandler) => (event: React.MouseEvent) => {
      if (originalOnMouseLeave) originalOnMouseLeave(event)

      setState(false)
    }

  if (typeof element === 'function') {
    element = element(state)
  }

  const el = React.cloneElement(element, {
    onMouseEnter: onMouseEnter(element.props.onMouseEnter),
    onMouseLeave: onMouseLeave(element.props.onMouseLeave),
  })

  return [el, state]
}

export default useHover
